import React from 'react';

import { errorCheck, validation } from 'assets';

interface ISuccessProps {
  status: 'error' | 'success';
  children: React.ReactChild;
}

const Status = ({ status, children, ...props }: ISuccessProps) => {
  return (
    <div className="text-center" {...props}>
      <img src={status === 'success' ? validation : errorCheck} className="mb-4" />
      {children}
    </div>
  );
};

export default Status;
